export default "__VITE_ASSET__Q6omSF7x__"